import { useTheme } from '@approvalmax/theme';
import { CheckIcon } from '@approvalmax/ui';
import { Flex, Spacing, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useMedia } from 'react-use';

import { ToggleLoginRegister } from '../../../../resources/components';
import { RegisterForm } from '../RegisterForm/RegisterForm';
import { advantages } from './Content.constants';
import { messages } from './Content.messages';

export const Content = memo(() => {
    const { theme } = useTheme();
    const xsmallViewport = useMedia(`(max-width: ${theme.container.breakpoint.xsmall})`);

    return (
        <Flex direction='column' spacing='40'>
            <ToggleLoginRegister />

            <Flex justifyContent='center'>
                <Flex direction='column' alignItems='center' spacing='0' maxWidth={400}>
                    <Text font='headline' fontSize='small' fontWeight='medium' spacing='0 0 16' as='h2'>
                        {messages.startTrial}
                    </Text>

                    <Flex direction={xsmallViewport ? 'column' : 'row'} spacing={xsmallViewport ? '8' : '16'}>
                        {advantages.map((advantage, index) => (
                            <Flex spacing='4' alignItems='center' key={index}>
                                <CheckIcon size={12} color='green100' />

                                <Text font='label' fontSize='small' color='midnight80'>
                                    {advantage}
                                </Text>
                            </Flex>
                        ))}
                    </Flex>

                    <Spacing height={32} />

                    <RegisterForm />
                </Flex>
            </Flex>
        </Flex>
    );
});

Content.displayName = 'Content';
